import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { approvedRejectedCampaignFailure, approvedRejectedCampaignSuccess } from '../../actions/campaignActions/approvedRejectedCampaignActions';
import store from '../../configStore';

function* approvedRejectedCampaign({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markApprovedRejectedCampaign,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("APPROVED_REJECTED_CAMPAIGN_SUCCESS status :", response.data.status);
        console.log("APPROVED_REJECTED_CAMPAIGN_SUCCESS data :", response.data.response);
        console.log("APPROVED_REJECTED_CAMPAIGN_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            approvedRejectedCampaignSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("APPROVED_REJECTED_CAMPAIGN_FAILURE status :", error?.response?.status);
        console.log("APPROVED_REJECTED_CAMPAIGN_FAILURE data:", error?.response?.data);
        console.log("APPROVED_REJECTED_CAMPAIGN_FAILURE error :", error);
        console.log('====================================');
        yield put(approvedRejectedCampaignFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* approvedRejectedCampaignSaga() {
    yield takeLatest(actionTypes.APPROVED_REJECTED_CAMPAIGN_REQUEST, approvedRejectedCampaign);
}

export default approvedRejectedCampaignSaga;
